var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 4.375V3.125H8.125V4.375H11.875V3.125H13.125V4.375H15.625C15.9702 4.375 16.25 4.65482 16.25 5V8.125H15V5.625H13.125V6.875H11.875V5.625H8.125V6.875H6.875V5.625H5V14.375H8.75V15.625H4.375C4.02983 15.625 3.75 15.3452 3.75 15V5C3.75 4.65482 4.02983 4.375 4.375 4.375H6.875ZM13.125 10C11.7443 10 10.625 11.1193 10.625 12.5C10.625 13.8807 11.7443 15 13.125 15C14.5057 15 15.625 13.8807 15.625 12.5C15.625 11.1193 14.5057 10 13.125 10ZM9.375 12.5C9.375 10.4289 11.0539 8.75 13.125 8.75C15.1961 8.75 16.875 10.4289 16.875 12.5C16.875 14.5711 15.1961 16.25 13.125 16.25C11.0539 16.25 9.375 14.5711 9.375 12.5ZM12.5 10.625V12.7589L13.9331 14.1919L14.8169 13.3081L13.75 12.2411V10.625H12.5Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.c8a01f11c810bf9817cfa15c02b887aa.svg";
export { ForwardRef as ReactComponent };